export default "__VITE_ASSET__1Kr5_bGL__"